import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import store from './store'
import CookieConsentPlugin from './plugins/cookieConsent'
import './assets/scss/main.scss'
import './assets/styles/animations.css'

const head = createHead()

// Create and mount the Vue application
const app = createApp(App)
app.use(store)
app.use(router)
app.use(head)
app.use(CookieConsentPlugin)
app.mount('#app')
